import React from 'react';
import { Link } from 'react-router-dom';

const CallToAction: React.FC = () => {
  return (
    <section className="bg-gradient-to-r from-purple-800 to-purple-900 py-16">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
          Ready for a Sparkling Clean Pool?
        </h2>
        <p className="text-xl text-white/90 mb-8 max-w-3xl mx-auto">
          No more stress about your pool maintenance. We handle the cleaning while you enjoy your pool!
        </p>
        <div className="bg-white/10 backdrop-blur-sm p-4 rounded-lg max-w-xl mx-auto mb-8">
          <p className="text-white font-medium">
            <span className="text-orange-400 font-bold">Special Offer:</span> First month FREE for new customers!
          </p>
        </div>
        <Link
          to="/quote"
          className="inline-block px-8 py-4 bg-orange-500 text-white font-bold rounded-md hover:bg-orange-600 transition-colors duration-200 text-center"
        >
          Get Your Free Quote Today
        </Link>
      </div>
    </section>
  );
};

export default CallToAction;